import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCode,
  setItemCountry,
  setItemRegion,
  setItemName,
  setItemCity, setItemNameTranslit,
} from '@/modules/Dictionary/__form/item';
import FInput from '@/plugins/form/FInput';

export default class DictionaryHotelForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'hotel';

  constructor(props = {}) {
    super(props);
    setItemName.bind(this)({ length: 300, lat: false });
    this.setItemNameRus();
    setItemNameTranslit.bind(this)({ length: 300 });
    setItemCode.bind(this)();
    setItemCountry.bind(this)();
    setItemRegion.bind(this)();
    setItemCity.bind(this)();
    this.setItemNameAddress();
    this.setItemNameCategory();
    this.setItemNameEMail();
    this.setItemNamePhone();
    this.setItemNameUrl();
    this.setItemNameComment();
  }

  setItemNameRus() {
    this.nameRus = new FInput({
      name: 'NameRus',
      label: 'Название (рус.)',
    });
    this.nameRus.setValidatorMax(50);
    this.setItem('nameRus', this.nameRus);
  }

  setItemNameAddress() {
    this.address = new FInput({
      name: 'Address',
      label: 'Адрес',
    });
    this.address.setValidatorMax(254);
    this.setItem('address', this.address);
  }

  setItemNameCategory() {
    this.category = new FInput({
      name: 'Category',
      label: 'Категория',
    });
    this.category.setValidatorMax(10);
    this.setItem('category', this.category);
  }

  setItemNameComment() {
    this.comment = new FInput({
      name: 'Comment',
      label: 'Комментарий',
    });
    this.comment.setValidatorMax(254);
    this.setItem('comment', this.comment);
  }

  setItemNameEMail() {
    this.email = new FInput({
      name: 'EMail',
      label: 'Email',
    });
    this.email.setValidatorMax(50);
    this.setItem('email', this.email);
  }

  setItemNamePhone() {
    this.phone = new FInput({
      name: 'Phone',
      label: 'Телефон',
    });
    this.phone.setValidatorMax(50);
    this.setItem('phone', this.phone);
  }

  setItemNameUrl() {
    this.url = new FInput({
      name: 'Url',
      label: 'Сайт',
    });
    this.url.setValidatorMax(128);
    this.setItem('url', this.url);
  }
}
